import type { SyncPreview, SyncPreviewCard } from '../../lib/vendorInvoiceApi';

/**
 * D110.3 — the category each NEW catalogue row is created under, picked on the
 * change card. The server suggests (`suggestedCategory`); the reviewer's pick
 * lives on the page as lineIndex -> category key ('' = no category).
 */

/** A card that offers a category: a new row the sync will actually write. */
export const offersCategory = (card: SyncPreviewCard, excluded: ReadonlySet<number> | number[]): boolean => {
  const isExcluded = Array.isArray(excluded) ? excluded.includes(card.lineIndex) : excluded.has(card.lineIndex);
  return card.outcome === 'new' && !!card.categorySuggestion && !isExcluded && card.forcedExcluded !== true;
};

/** Where each new card starts: on the AI's pick, or on "No category". */
export function startingCategoryChoices(preview: SyncPreview): Record<number, string> {
  const out: Record<number, string> = {};
  for (const card of preview.cards) {
    if (card.outcome === 'new' && card.categorySuggestion) out[card.lineIndex] = card.suggestedCategory?.key ?? '';
  }
  return out;
}

/**
 * The `categoryChoices` the confirm sends: one entry per included new card
 * with a category picked. "No category" sends nothing (the server refuses a
 * blank value; a missing entry means the row is created with no category).
 */
export function categoryChoicesToSend(
  preview: SyncPreview,
  choices: Record<number, string>,
  excluded: number[]
): Record<string, string> {
  const out: Record<string, string> = {};
  for (const card of preview.cards) {
    if (!offersCategory(card, excluded)) continue;
    const key = choices[card.lineIndex];
    if (key) out[String(card.lineIndex)] = key;
  }
  return out;
}
